// extracted by mini-css-extract-plugin
module.exports = {"container":"MarkAsDuplicateModal_container__QiUum","actions":"MarkAsDuplicateModal_actions__Y5sD4"};